(function() {
    'use strict';
    /**
     Enhances an element to simulate a bubble notification. See PGRTOF-2556 UX specs for more info
     @param {jquery} wrapper - DOM Object
     @param {Object} opts
     @return {jquery}
     */
    Odigeo.UIElements.enhanceBubbleNotification = function(wrapper, opts) {
        var $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
        var defaults = {showBubbleWhenZero: false};
        var options = _.extend(defaults, opts);
        var $bubbleValue;
        var onUpdateCount;
        var onHideBubble;
        var onShowBubble;
        var $bubbleWrapper;

        if ($wrapper.attr('data-skip-enhance') === 'true') {
            return;
        }

        $wrapper.attr({'data-skip-enhance': true});
        $bubbleWrapper = $('<div>', {'class': 'od-bubble-notification-number-wrapper'});
        $bubbleValue = $('<div>', {'class': 'bubble_value od-bubble-notification-number'});
        $bubbleWrapper.append($bubbleValue);
        $wrapper.append($bubbleWrapper);

        onUpdateCount = function(evt, count) {
            $bubbleValue.html(count);
            $wrapper.toggleClass('hidden', !options.showBubbleWhenZero ? count === 0 : false);
        };

        onShowBubble = function() {
            $wrapper.removeClass('hidden');
        };

        onHideBubble = function() {
            $wrapper.addClass('hidden');
        };

        $wrapper.on('updateCount', onUpdateCount);
        $wrapper.on('showBubble', onShowBubble);
        $wrapper.on('hideBubble', onHideBubble);

        return $wrapper;
    };
}());
